export const REFERRAL_ACCOUNT_IDENTIFIER_PARAM_KEY = 'refAccountID';
export const DISCLOSURE_KEY = 'disclosure';
export const RETURN_URL_KEY = 'returnUrl';
